<!-- Uploaded to: SVG Repo, www.svgrepo.com, Transformed by: SVG Repo Mixer Tools -->
<svg
	fill="currentColor"
	version="1.1"
	id="Capa_1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	width="30px"
	height="30px"
	viewBox="0 0 235.953 235.953"
	xml:space="preserve"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<g>
			<g>
				<rect x="6.858" y="80.054" width="15.092" height="87.021" />
				<polygon points="6.858,168.939 0,173.946 28.808,173.946 21.95,168.939 " />
				<circle cx="14.439" cy="70.097" r="8.091" />
				<rect x="214.006" y="80.054" width="15.082" height="87.021" />
				<polygon points="229.098,168.939 214.006,168.939 207.146,173.946 235.953,173.946 " />
				<path
					d="M221.583,62.007c4.468,0,8.094,3.621,8.094,8.09c0,4.468-3.626,8.091-8.094,8.091c-4.464,0-8.085-3.623-8.085-8.091 C213.498,65.628,217.119,62.007,221.583,62.007z"
				/> <rect x="63.962" y="82.52" width="30.523" height="10.971" />
				<rect x="141.473" y="82.52" width="30.523" height="10.971" />
				<rect x="102.717" y="82.52" width="30.524" height="10.971" />
				<rect x="24.009" y="82.52" width="31.722" height="10.971" />
				<rect x="180.228" y="82.52" width="31.036" height="10.971" />
				<rect x="24.009" y="119.561" width="31.722" height="10.969" />
				<rect x="180.228" y="119.561" width="31.036" height="10.969" />
				<rect x="102.717" y="119.561" width="30.524" height="10.969" />
				<rect x="63.962" y="119.561" width="30.523" height="10.969" />
				<rect x="141.473" y="119.561" width="30.523" height="10.969" />
			</g>
		</g>
	</g>
</svg>
